import axios from "axios";
import { API_URL, getAuthHeader } from ".";
import { State } from "../Models/State";
import { UserLevel } from "../Models/UserLevel";
import { Industry } from "../Models/Industry";
import { FileType } from "../Models/FileType";
import { ResponseModel } from "../Models/ResponseModel";
import { PageType } from "../Models/PageType";
import { Subscription } from "../Models/Subscription";
import { Tag } from "../Models/Tag";
import { File as ImageFile } from "../Models/File";
import { Manufacturer } from "../Models/Manufacturer";
import { EquipmentSearchData } from "../Models/EquipmentSearchData";
import { CustomOption } from "../Models/CustomOption";
import { Category } from "../Models/Category";
import { SubCategory } from "../Models/SubCategory";
import { CategoryCustom } from "../Models/CategoryCustom";
import { EquipmentCustom } from "../Models/EquipmentCustom";
import { ManualDisplay } from "../Models/ManualDisplay";
import { Territory } from "../Models/Territory";
import { SubCategoryCustom } from "../Models/SubCategoryCustom";
import { OldManualList } from "../Models/OldManualList";

class CommonApi {
  static getStates() {
    return axios.get<State[]>(`${API_URL}/api/common/states`, getAuthHeader());
  }
  static getUserLevels() {
    return axios.get<UserLevel[]>(
      `${API_URL}/api/common/userlevels`,
      getAuthHeader()
    );
  }
  static getIndustries() {
    return axios.get<Industry[]>(
      `${API_URL}/api/common/industries`,
      getAuthHeader()
    );
  }
  static getFileTypes() {
    return axios.get<FileType[]>(
      `${API_URL}/api/common/filetypes`,
      getAuthHeader()
    );
  }
  static getSubscriptions() {
    return axios.get<Subscription[]>(
      `${API_URL}/api/common/subscriptions`,
      getAuthHeader()
    );
  }
  static addFile(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/addFile`,
      request,
      getAuthHeader()
    );
  }
  static updateFile(request: ImageFile) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/updateFile`,
      request,
      getAuthHeader()
    );
  }
  static deleteFile(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/common/deleteFile/${id}`,
      getAuthHeader()
    );
  }
  static setFilePrimary(id: number) {
    return axios.put<ResponseModel>(
      `${API_URL}/api/common/primaryFile/${id}`,
      null,
      getAuthHeader()
    );
  }
  static getPageTypes() {
    return axios.get<PageType[]>(
      `${API_URL}/api/common/pagetypes`,
      getAuthHeader()
    );
  }

  static GetFilesBySitePage(id: number) {
    return axios.get<ImageFile[]>(
      `${API_URL}/api/common/GetFilesBySitePage/${id}`
      // getAuthHeader()
    );
  }
  static getCustomOptions() {
    return axios.get<CustomOption[]>(`${API_URL}/api/common/customoptions`);
  }
  static getExistingEmails() {
    return axios.get<string[]>(`${API_URL}/api/common/existingemails`);
  }
  static getEquipmentSearchData() {
    return axios.get<EquipmentSearchData>(
      `${API_URL}/api/common/equipmentSearchData`
    );
  }
  static getCategories() {
    return axios.get<Category[]>(`${API_URL}/api/common/categories`);
  }
  static getCategoriesCustom() {
    return axios.get<CategoryCustom[]>(
      `${API_URL}/api/common/categoriescustom`
    );
  }
  static getSubCategories() {
    return axios.get<SubCategory[]>(`${API_URL}/api/common/subcategories`);
  }
  static getSubCategoriesCustom() {
    return axios.get<SubCategoryCustom[]>(
      `${API_URL}/api/common/subcategoriescustom`,
      getAuthHeader()
    );
  }
  static getEquipmentListCustom() {
    return axios.get<EquipmentCustom[]>(
      `${API_URL}/api/common/equipmentlistcustom`,
      getAuthHeader()
    );
  }
  static getTerritoryList() {
    return axios.get<Territory[]>(
      `${API_URL}/api/common/territoryList`,
      getAuthHeader()
    );
  }
  static getManuals() {
    return axios.get<ImageFile[]>(
      `${API_URL}/api/common/manuallist`,
      getAuthHeader()
    );
  }
  static getManualsCustom(manufacturerId: string) {
    return axios.get<ManualDisplay[]>(
      `${API_URL}/api/common/manualscustom/manufacturer/${manufacturerId}`
    );
  }
  static getAllOldManuals() {
    return axios.get<OldManualList[]>(
      `${API_URL}/api/common/oldmanuallist`,
      getAuthHeader()
    );
  }
  static getOldManuals(manufacturerId: string | null) {
    return axios.get<OldManualList[]>(
      `${API_URL}/api/common/oldmanuallist/${manufacturerId}`,
      getAuthHeader()
    );
  }
  static updateOldManual(data: OldManualList) {
    return axios.post<OldManualList>(
      `${API_URL}/api/common/addUpdateOldManual`,
      data,
      getAuthHeader()
    );
  }
  static deleteOldManual(id: number) {
    return axios.get<boolean>(
      `${API_URL}/api/common/deleteOldManual/${id}`,
      getAuthHeader()
    );
  }
  static getOldManual(id: string) {
    return axios.get<OldManualList>(
      `${API_URL}/api/common/getOldManual/${id}`,
      getAuthHeader()
    );
  }

  // Category CRUD operations
  static addUpdateCategory(category: CategoryCustom) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/addUpdateCategory`,
      category,
      getAuthHeader()
    );
  }

  static deleteCategory(number: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/common/deleteCategory/${number}`,
      getAuthHeader()
    );
  }

  // SubCategory CRUD operations
  static addUpdateSubCategory(subCategory: SubCategory) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/addUpdateSubCategory`,
      subCategory,
      getAuthHeader()
    );
  }

  static deleteSubCategory(number: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/common/deleteSubCategory/${number}`,
      getAuthHeader()
    );
  }
}

export default CommonApi;
